customElements.define('custom-edit-account-form', class extends HTMLElement {
  submitData = {};
  constructor() {
    super();
    this.email = this.querySelector("#EditAccountEmail");
    this.subscribeEmail = this.querySelector("#EditAccountSubscribeEmail");
    this.subscribeSMS = this.querySelector("#EditAccountSubscribeSMS");
    this.subscribeWhatapps = this.querySelector("#EditAccountSubscribeWhatsApp");
    this.cstmIntgSeq = this.querySelector("#EditAccountCstmIntgSeq");

    this.querySelector(`form .btn-wrapper`)?.addEventListener('click', (e) => {
      const formValidate = this.handleProcessForm();
      if (formValidate.type !== "success") return;
      const formData = new FormData(this.querySelector('form'));
      const obj = {};
      for (const [name, value] of formData) {
        obj[name] = value;
      }

      const inputBirthDay = obj["birthday-day"] && obj["birthday-month"] && obj["birthday-year"]
        ? `${obj["birthday-day"]}/${obj["birthday-month"]}/${obj["birthday-year"]}`
        : "";

      this.submitData.emailYN = obj.subscribe_email === 'email' ? 'Y' : 'N';
      this.submitData.smsYN = obj.subscribe_sms === 'sms' ? 'Y' : 'N';
      this.submitData.etcYN = obj.subscribe_whatsapp === '01' ? '01' : '';
      this.submitData.sex = obj.gender
        ? (obj.gender === "M" || obj.gender === "Male")
          ? 'M'
          : 'F'
        : "";

      this.submitData.uid = obj.uid;
      this.submitData.firstName = obj.first_name;
      this.submitData.lastName = obj.last_name;
      this.submitData.mobileNo = obj.mobileNo;
      this.submitData.cstmIntgSeq = obj.cstmIntgSeq ?? "";
      this.submitData.metafields = [];
      this.submitData.email = obj.email;

      for (let i in window.RACES) {
        const item = window.RACES[i];
        if (obj.race === item.label || obj.race === item.value) {
          this.submitData.race = item.value;
          break;
        }
      }

      if (this.submitData.sex) {
        this.submitData.metafields.push({
          namespace: window.METAFIELDS.GENDER.namespace,
          key: window.METAFIELDS.GENDER.key,
          value: this.submitData.sex
        })
      }

      if (obj.birthDay || inputBirthDay) {
        const birthDayStr = obj.birthDay ?? inputBirthDay;
        const birthDayArr = birthDayStr.split('/').reverse().map(item => item.padStart(2, '0'));
        this.submitData.birthDay = birthDayArr.join("");

        this.submitData.metafields.push({
          namespace: window.METAFIELDS.BIRTHDAY.namespace,
          key: window.METAFIELDS.BIRTHDAY.key,
          value: birthDayArr.join("-")
        })
      }

      if (this.submitData.race) {
        this.submitData.metafields.push({
          namespace: window.METAFIELDS.RACE.namespace,
          key: window.METAFIELDS.RACE.key,
          value: this.submitData.race
        });
      }

      this.submitData.metafields.push({
        namespace: window.METAFIELDS.ETC_YN.namespace,
        key: window.METAFIELDS.ETC_YN.key,
        value: this.submitData.etcYN || ""
      });

      this.handleSubmitForm(this.submitData)
    })

    this.handleFetchInitData();
  }

  handleProcessForm() {
    let type = 'success';
    const requiredFields = this.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      const ancestorNode = field.id === "AddressProvinceNew"
        ? field.closest('#AddressProvinceContainerNew')
        : field.closest('[id^="FormField-"]');

      const errorField = ancestorNode.querySelector('.form-field__text--error');
      if (
        (field.type === "radio" && this.querySelectorAll(`input[name="${field.name}"]:checked`).length === 0) ||
        (field.type !== "radio" && !field.value.trim())
      ) {
        errorField?.classList?.remove('hidden');
        type = 'error';
      } else {
        errorField?.classList?.add('hidden');
      }
    })
    const dateOfBirthFields = Array.from(this.querySelectorAll('select[id^="EditAccountDateOfBirth"]'));
    const dateOfBirthFieldsWrapper = this.querySelector('#FormField-editAccountBirthday');
    const errorField = dateOfBirthFieldsWrapper.querySelector('.form-field__text--error');
    const hasSomeEmptyValues = dateOfBirthFields.some(field => !field.value);
    const hasAllEmptyValues = dateOfBirthFields.every(field => !field.value);
    const hasAllFilledValues = dateOfBirthFields.length > 0 && dateOfBirthFields.every(field => field.value);
    if (hasAllEmptyValues) {
      errorField?.classList?.add('hidden');
    } else if (hasSomeEmptyValues) {
      errorField?.classList?.remove('hidden');
      type = 'error';
    } else if (hasAllFilledValues) {
      const birthdayYearField = this.querySelector('#EditAccountDateOfBirthYear');
      const birthdayMonthField = this.querySelector('#EditAccountDateOfBirthMonth');
      const birthdayDayField = this.querySelector('#EditAccountDateOfBirthDay');
      const check = this.handleValidateDate({ year: birthdayYearField.value, month: birthdayMonthField.value, day: birthdayDayField.value });

      if (check) {
        errorField.innerText = "* This is a required field";
        errorField?.classList?.add('hidden');
      } else {
        errorField.innerText = "* Date is not valid.";
        errorField?.classList?.remove('hidden');
        type = 'error';
      }
    }

    return { type }
  }

  handleValidateDate({ year, month, day }) {
    const yearInt = parseInt(year);
    const monthInt = parseInt(month) - 1; // 0-indexed (Jan=0, Feb=1)
    const dayInt = parseInt(day);
    const d = new Date(yearInt, monthInt, dayInt);
    return d.getFullYear() === yearInt &&
      d.getMonth() === monthInt &&
      d.getDate() === dayInt;
  }

  async handleFetchInitData() {
    const phoneField = this.querySelector("#EditAccountPhoneNumber");
    if (!phoneField?.value) return;
    const url = window.middlewareUrls.memberCheck;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobileNo: phoneField.value,
          email: this.email?.value,
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      const data = resJson.data.data.customerInfo;
      const initData = { ...data, mobileNo: data.mobileNo?.replace(/^0/, window.phonePrefix) };
      delete initData.cstmGradeCD
      delete initData.cstmGradeNM;
      delete initData.empID;
      delete initData.mgm;
      this.handleSetInitData(initData, true)
    } catch (error) {
      console.error(error.message);
    }
  }

  handleSetInitData(data = {}, initLoad = false) {
    this.submitData = data;
    if (initLoad) {
      this.subscribeSMS.checked = data.smsYN === "Y";
      this.querySelector('.loading-mask')?.remove();
      this.querySelector('form').classList.remove('custom-visually-hidden');
      return;
    }

    if (data.sex) {
      this.querySelector(`[name="gender"][value="${data.sex}"]`).setAttribute("checked", "")
    }

    if (data.birthDay) {
      const dayField = this.querySelector('#EditAccountDateOfBirthDay');
      const monthField = this.querySelector('#EditAccountDateOfBirthMonth');
      const yearField = this.querySelector('#EditAccountDateOfBirthYear');
      if (dayField) dayField.value = data.birthDay.slice(6, 8);
      if (monthField) monthField.value = data.birthDay.slice(4, 6);
      if (yearField) yearField.value = data.birthDay.slice(0, 4);
    }

    if (data.firstName) {
      this.querySelector('#EditAccountFirstName').value = data.firstName;
    }

    if (data.lastName) {
      this.querySelector('#EditAccountLastName').value = data.lastName;
    }

    this.subscribeEmail.checked = data.emailYN === "Y";
    this.subscribeSMS.checked = data.smsYN === "Y";
    this.subscribeWhatapps.checked = data.etcYN?.includes("01");

    // must be set at the end whether there is data or not
    this.cstmIntgSeq.value = data.cstmIntgSeq ?? "";
  }

  async handleSubmitForm(data) {
    const loadingBtn = this.querySelector('button[type="button"] .loading__spinner');
    loadingBtn.classList.remove('hidden');
    const url = window.middlewareUrls.memberUpdate
    try {
      const resSubmit = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      if (!resSubmit.ok) {
        throw new Error(`Response status: ${resSubmit.status}`);
      }

      const resJson = await resSubmit.json();

      const resData = resJson.data;
      if (resData) {
        window.location.reload();
      }
    } catch (e) {
      console.error(e)
    } finally {
      loadingBtn.classList.add('hidden');
    }
  }
})